import { useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { ContractsSettingPageQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import ApprovalsBlock from 'modules/approvals/components/ApprovalsConfigurationBlock'
import ContractTaxonomies from 'modules/contracts_settings/components/ContractFields'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const AggrementApprovals = () => {
  const { data, loading, error } = useOutletContext<{
    data: ContractsSettingPageQuery
    loading: boolean
    error: unknown
  }>()

  const canEdit = !!data?.contracts._policies.contractEditContractsSettings.can
  const hasDevCompensations =
    data?.features?.featuresConnection.nodes.some(
      (feature) => feature.name === 'dev_compensations' && feature.enabled
    ) ?? false

  const companyTemplatesTaxonomies = data?.contracts.contractTemplatesConnection.nodes || []

  return (
    <ResponsivePage.Body
      variant="wide"
      authorized={canEdit}
      showHeader={false}
      loading={loading}
      error={error}
    >
      <Box gap="s32" width="full" gapDivider>
        <ApprovalsBlock
          icon="document-approved"
          category="contracts"
          title={i18n.t('company_settings.general.employment_data.approvals.title')}
          description={i18n.t('company_settings.general.employment_data.approvals.description')}
          helpCenterUrlName="about-contracts-approval-system"
          noPadding
        />
        {!!companyTemplatesTaxonomies.length && (
          <ContractTaxonomies
            companyTemplatesTaxonomies={companyTemplatesTaxonomies}
            hasDevCompensations={hasDevCompensations}
          />
        )}
      </Box>
    </ResponsivePage.Body>
  )
}

export default AggrementApprovals
